import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'
import axios from 'axios'

export type OrderTransmissionServiceType = {
  payload: {
    orderId: string | string[],
  }
}

export const orderTransmissionService = async ({
  payload,
}: OrderTransmissionServiceType): Promise<ResponseAPI> => {
  const response = await api.get(`transmitir/${payload.orderId}`)
  return response.data
}
